/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

if(document.getElementById('modal-search')){
  
  document.getElementById('modal-search').addEventListener('on:modal:opening', (event) => {
    document.body.classList.add('search__modal--open');
  });

  document.getElementById('modal-search').addEventListener('on:modal:closed', (event) => {
    document.body.classList.remove('search__modal--open');
  });
  
}

if(document.getElementById('modal-main-menu')){
  
  document.getElementById('modal-main-menu').addEventListener('on:modal:opening', (event) => {
    document.body.classList.add('mobile__menu--modal-open');
  });

  document.getElementById('modal-main-menu').addEventListener('on:modal:closed', (event) => {
    document.body.classList.remove('mobile__menu--modal-open');
  });  
  
}

if(document.querySelector(".header-trigger__close")){
  document.querySelector(".header-trigger__close").addEventListener("click", function() {
    const navCloseButton = document.querySelector(".modal--main-menu .modal__close");
    if(navCloseButton){
      const event = new Event("click");
      navCloseButton.dispatchEvent(event);
    }
  });
}

if(document.querySelector(".search-trigger__close")){
  document.querySelector(".search-trigger__close").addEventListener("click", function() {
    const searchCloseButton = document.querySelector(".modal--search .modal__close");
    if(searchCloseButton){
      const event = new Event("click");
      searchCloseButton.dispatchEvent(event);
    }
  });
}


// Account Modal

// document.addEventListener("DOMContentLoaded", function () {
//   const accountTrigger = document.querySelector(".account-trigger-icon .secondary-nav__link");
//   const accountClose = document.querySelector(".account-trigger__close");
//   const accountModal = document.querySelector(".account_modal");

//   if (accountTrigger && accountModal) {
//       accountTrigger.addEventListener("click", function (event) {
//           event.preventDefault();
          
//           accountModal.classList.remove("is-closing");
//           accountModal.classList.add("is-opening");
          
//           document.body.classList.add("account__modal--open");
//       });
//   }

//   if (accountClose && accountModal) {
//       accountClose.addEventListener("click", function () {
//           accountModal.classList.remove("is-opening");
//           accountModal.classList.add("is-closing");
          
//           setTimeout(() => {
//               document.body.classList.remove("account__modal--open");
//               accountModal.classList.remove("is-closing");
//           }, 200);
//       });
//   }
// });


